import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=43c3066c&scoped=true"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"
import style0 from "./Project.vue?vue&type=style&index=0&id=43c3066c&prod&lang=css"
import style1 from "./Project.vue?vue&type=style&index=1&id=43c3066c&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c3066c",
  null
  
)

export default component.exports